import { createSlice } from '@reduxjs/toolkit';
import { camelCase, isEmpty } from 'lodash';
import { UiState } from 'constants/ui';
import { actions as checkoutActions } from 'state/checkout/slice';
import { actions as conversationActions } from 'state/conversation/slice';
import { actions as returnShipmentActions } from 'state/return-shipment/slice';
import { stateName } from './constants';
export const initialUiState = {
  configuration: UiState.Idle,
  shippingContact: UiState.Idle,
  saveShippingContact: UiState.Idle,
  deleteShippingContact: UiState.Idle
};
export const initialState = {
  configuration: null,
  buyerPhoneNumber: null,
  sellerPhoneNumber: null,
  errors: [],
  ui: initialUiState
};

const setShippingContactUiState = uiState => draft => {
  draft.ui.shippingContact = uiState;
};

const fetchShippingContactConfigurationRequest = draft => {
  draft.ui.configuration = UiState.Pending;
};

const fetchShippingContactConfigurationSuccess = (draft, action) => {
  const {
    configuration
  } = action.payload;
  draft.configuration = configuration;
  draft.ui.configuration = UiState.Success;
};

const fetchShippingContactConfigurationFailure = draft => {
  draft.ui.configuration = UiState.Failure;
};

const saveTransactionShippingContactRequest = draft => {
  draft.ui.saveShippingContact = UiState.Pending;
};

const saveTransactionShippingContactSuccess = (draft, action) => {
  const {
    buyerPhoneNumber,
    sellerPhoneNumber
  } = action.payload;
  draft.buyerPhoneNumber = buyerPhoneNumber;
  draft.sellerPhoneNumber = sellerPhoneNumber;
  draft.ui.saveShippingContact = UiState.Success;
};

const saveTransactionShippingContactFailure = (draft, action) => {
  const {
    error
  } = action.payload;
  if (!isEmpty(error)) draft.errors.push(error);
  draft.ui.saveShippingContact = UiState.Failure;
};

const deleteTransactionShippingContactRequest = draft => {
  draft.ui.deleteShippingContact = UiState.Pending;
};

const deleteTransactionShippingContactSuccess = draft => {
  draft.buyerPhoneNumber = null;
  draft.sellerPhoneNumber = null;
  draft.ui.deleteShippingContact = UiState.Success;
};

const deleteTransactionShippingContactFailure = draft => {
  draft.ui.deleteShippingContact = UiState.Failure;
};

const setShippingContactField = (draft, action) => {
  const {
    name,
    value
  } = action.payload;
  const field = camelCase(name);
  draft[field] = value || draft[field] || '';
};

const setShippingContactError = (draft, action) => {
  const {
    error
  } = action.payload;
  draft.errors.push(error);
};

const removeShippingContactError = (draft, action) => {
  const {
    error
  } = action.payload;
  draft.errors = draft.errors.filter(_ref => {
    let {
      field,
      value
    } = _ref;
    return field !== error.field && value !== error.value;
  });
};

const removeShippingContactErrors = draft => {
  draft.errors = [];
};

const setShippingContactFields = (draft, action) => {
  draft.ui.shippingContact = UiState.Success;
  draft.buyerPhoneNumber = action.payload.checkout.buyer.phoneNumber;
};

const setShippingContactFieldsOnTransactionRequestSuccess = (draft, action) => {
  if (!action.payload.transaction) return;
  const {
    buyerPhoneNumber,
    sellerPhoneNumber
  } = action.payload.transaction;
  draft.buyerPhoneNumber = buyerPhoneNumber;
  draft.sellerPhoneNumber = sellerPhoneNumber;
  draft.ui.shippingContact = UiState.Success;
};

const setShippingContactFieldsOnReturnShipmentSuccess = (draft, action) => {
  const {
    phoneNumber
  } = action.payload;
  draft.sellerPhoneNumber = phoneNumber;
  draft.ui.shippingContact = UiState.Success;
};

const setShippingContactFieldUiState = (draft, action) => {
  const {
    field,
    uiState
  } = action.payload;
  draft.ui[camelCase[field]] = uiState;
};

const shippingContactSlice = createSlice({
  name: stateName,
  initialState,
  reducers: {
    fetchShippingContactConfigurationRequest,
    fetchShippingContactConfigurationSuccess,
    fetchShippingContactConfigurationFailure,
    saveTransactionShippingContactRequest,
    saveTransactionShippingContactSuccess,
    saveTransactionShippingContactFailure,
    deleteTransactionShippingContactRequest,
    deleteTransactionShippingContactSuccess,
    deleteTransactionShippingContactFailure,
    setShippingContactField,
    setShippingContactError,
    removeShippingContactError,
    removeShippingContactErrors,
    setShippingContactFieldUiState
  },
  extraReducers: {
    [checkoutActions.updateCheckoutDataRequest.type]: setShippingContactUiState(UiState.Pending),
    [checkoutActions.updateCheckoutDataSuccess.type]: setShippingContactFields,
    [conversationActions.fetchTransactionRequestSuccess.type]: setShippingContactFieldsOnTransactionRequestSuccess,
    [returnShipmentActions.getReturnShipmentSuccess.type]: setShippingContactFieldsOnReturnShipmentSuccess
  }
});
export const {
  actions
} = shippingContactSlice;
export const plug = {
  [stateName]: shippingContactSlice.reducer
};
export default shippingContactSlice.reducer;